import LaneEntityImageBase from './LaneEntityImageBase';
import Obstacle, { ObstacleName, ObstacleNameValues } from './entities/obstacle/Obstacle';
import ObstacleBananaSkin from './entities/obstacle/ObstacleBananaSkin';
import ObstacleBoxes from './entities/obstacle/ObstacleBoxes';
import ObstacleOilSlick from './entities/obstacle/ObstacleOilSlick';
import ObstacleWetConcrete from './entities/obstacle/ObstacleWetConcrete';
import ObstacleIcePatch from './entities/obstacle/ObstacleIcePatch';
import ObstacleLeafPile from './entities/obstacle/ObstacleLeafPile';
import ObstacleMudPatch from './entities/obstacle/ObstacleMudPatch';
import ObstacleSnowDrift from './entities/obstacle/ObstacleSnowDrift';

export class ObstacleFactory {
  public static obstaclesToSpawn: typeof Obstacle[] = [
    ObstacleBananaSkin,
    ObstacleBoxes,
    ObstacleOilSlick,
    ObstacleWetConcrete,
    ObstacleIcePatch,
    ObstacleLeafPile,
    ObstacleMudPatch,
    ObstacleSnowDrift
  ];
  public static obstacleNameToClass: Record<ObstacleNameValues, typeof Obstacle> = {
    [ObstacleName.ObstacleBananaSkin]: ObstacleBananaSkin,
    [ObstacleName.ObstacleBoxes]: ObstacleBoxes,
    [ObstacleName.ObstacleOilSlick]: ObstacleOilSlick,
    [ObstacleName.ObstacleWetConcrete]: ObstacleWetConcrete,
    [ObstacleName.ObstacleIcePatch]: ObstacleIcePatch,
    [ObstacleName.ObstacleLeafPile]: ObstacleLeafPile,
    [ObstacleName.ObstacleMudPatch]: ObstacleMudPatch,
    [ObstacleName.ObstacleSnowDrift]: ObstacleSnowDrift
  };

  protected scene: Phaser.Scene;
  protected isInitialised: boolean;
  protected groups: Map<typeof LaneEntityImageBase, Phaser.GameObjects.Group>;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.isInitialised = false;

    this.groups = new Map();
  }

  public static convertObstacleNamesToClasses(names: ObstacleNameValues[]): typeof Obstacle[] {
    let classes: typeof Obstacle[] = [];

    for (const name of names) {
      classes.push(this.obstacleNameToClass[name]);
    }

    return classes;
  }

  public init() {
    // if (this.isInitialised) return;
    this.groups = new Map();

    ObstacleFactory.obstaclesToSpawn.forEach((obstacleClass) => {
      if (!this.groups.has(obstacleClass)) {
        let group = this.scene.add.group([], { classType: obstacleClass });
        this.groups.set(obstacleClass, group);

        // for (let i = 0; i < 10; i++) {
        //   group.create(-1000, 0, undefined, undefined, false, false);
        // }
      }
    });

    // this.isInitialised = true;
  }

  public makeObstacle<T extends Obstacle>(
    obstacleClass: typeof Obstacle,
    x: number,
    y: number
    // onHitCallback?: (self: LaneEntityImageBase) => void
  ): T | undefined {
    if (obstacleClass) {
      let group = this.groups.get(obstacleClass) as Phaser.GameObjects.Group;
      let obstacle = group.get() as T;
      // obstacle.init(onHitCallback);
      obstacle.init();
      obstacle.reset();
      obstacle.x = x;
      obstacle.y = y + obstacle.spawnOffsetY;

      return obstacle;
    }
  }
}
